<template>
  <div class="cloud-wrap">
    <div class="clearfix">
      <div
        class="noCycle-main clearfix"
        v-loading.body="loading">
        <div class="hover-cloud">
          <!--默认无 显示层 S-->
          <div
            class="cycle-cont hover-mask2"
            :class="cloudData.length > 0 ? 'cycle-confirmed' : 'cycle-noconfirmed'">
            <div class="cycle-ico">
              <i class="el-icon-upload"/>
            </div>
            <div>{{ this.title }}</div>
          </div>
          <!--默认无 显示层 E-->
          <!--鼠标放上 出现 S-->
          <div class="cycle-hover hover-mask clearfix">
            <div>
              <!--:upload-additional="{upload_position: uploadPosition.upload_position, upload_type_str: item.file_name, offer_school_id: uploadPosition.offer_school_id, upload_type: item.id}"-->
              <jm-upload-file
                :url="uploadUrl"
                :upload-data="uploadData"
                :show-file-list="false"
                @upload-get-info="uploadGetInfo"
              >
                <template slot="uploadFile">
                  <el-button
                    type="primary"
                    size="small">上传</el-button>
                </template>
              </jm-upload-file>
            </div>
            <div>
              <!--:disabled="item.file_list.length === 0"-->
              <!--@click="setPreview({upload_position: uploadPosition.upload_position, upload_type_str: item.file_name, offer_school_id: uploadPosition.offer_school_id, upload_type: item.id}, item.id,item.file_list[0])"-->
              <el-button
                :disabled="cloudData.length === 0"
                type="primary"
                size="small"
                @click="setPreview()"
              >预览</el-button>
            </div>
          </div>
          <!--鼠标放上 出现 E-->
        </div>
      </div>
    </div>
    <!--设置材料显示层 start-->
    <el-dialog
      :visible.sync="setDataVisible"
      class="dialog-disk"
      title="设置材料"
      @close="dialogClose">
      <jm-newTableCheckbox
        ref="tableCheckbox"
        title="设置材料"
        subtitle="报名材料"
        @dialog-disk-visible="dialogDiskVisible"
        :upload-data="uploadData"
        :upload-position="uploadPosition"
        :cloud-disk-data.sync="setCloudData"
      />
    </el-dialog>
    <!--设置材料显示层 end-->
    <!--走马灯 预览展示 start-->
    <img
      v-show="false"
      ref="vueimg"
      :allDel="true"
      :label="itemFile.id"
      v-img="{ group: `group_${qufen}_${uploadData.field_name}` }"
      v-for="itemFile in cloudData"
      :key="itemFile.picurl"
      :src="itemFile.picurl">
    <!--走马灯 预览展示 end-->
    <div
      class="rotate-area del-rotate"
      @click="delPic($event)"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import VueImg from '@/plugins/v-img';
import newTableCheckbox from '@/components/tool/newTableCheckbox';
import { jmUploadFile } from '@/components/tool';
import { messageBox } from '@/utils/messagebox';

Vue.use(VueImg);
const msgObj = {
  message: '此操作将删除材料, 是否继续?',
};
const countryId = {
  country_id: 485,
};
//  let tempCurrent = {};

export default {
  props: {
    /*
       * 上传Url
       * */
    uploadUrl: {
      type: String,
      required: true
    },
    /*
       * 上传请求参数
       * */
    uploadData: {
      type: Object,
      default() {
        return {};
      },
    },
    /*
       * 上传位置
       * */
    uploadPosition: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default: ''
    },
    qufen: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false, // Loading
      setCloudData: [],
      checkList: [],
      cloudData: [], // 初始化数据
      setDataVisible: false,
      picFilesUrl: [], // 预览图片
      setuploadData: {}, // 临时跑拼接数据
      previewData: {}, // 临时上传参数数据
      currentGroup: '',
      cloudDataEmpty: true
    };
  },
  methods: {
    /*
       * 初始化数据
       * */
    getDiskInfo() {
      this.loading = true;
      return this.$http._post({
        url: '/index/base_process/getWenanLiuchengImg',
        data: this.uploadData,
      }).then((res) => {
        this.loading = false;
        this.cloudData = res.data;
        if (this.cloudData.length === 0) {
          this.cloudDataEmpty = true;
        } else {
          this.cloudDataEmpty = false;
        }
        this.$emit('cloudDataEmptyFlag', this.cloudDataEmpty);
      });
    },

    /*
       * 设置材料
       * */
    dialogClose() {
      this.$refs.tableCheckbox.closeMeterial();
    },
    /*
       * 确认 and 驳回
       * */
    setConfirmed (collection, status) {
      let data1 = {};
      let data2 = countryId;
      Object.assign(data1, data2, this.uploadData, { ...collection }, { status });
      this.$http._post({
        url: '/index/apply_file/setStatus',
        data: data1,
      }).then(() => {
        this.getDiskInfo();
      });
    },
    /*
       * 预览云盘材料
       * */
    setPreview () {
      //          group_${qufen}_${uploadData.field_name}
      if (this.cloudData.length > 0) {
        document.querySelectorAll(`[data-vue-img-group=group_${this.qufen}_${this.uploadData.field_name}`)[0].click();
        this.$el.querySelectorAll('.rotate-area').forEach((item) => {
          item.style.display = 'block';
        });
      }
    },
    /*
       * 删除预览图片
       * */
    delPic(a) {
      console.log(a);
      let imgurl = document.querySelector('.delUrl').src;
      imgurl = imgurl.substring(imgurl.indexOf('/Uploads'));
      messageBox.msgBox(msgObj).then(() => {
        this.$http._post({
          url: '/index/base_process/delWenanLiuchengImg',
          data: { picurl: imgurl },
        }).then(() => {
          this.getDiskInfo().then(() => {
            let data = this.$el.querySelectorAll(`[data-vue-img-group=group_${this.qufen}_${this.uploadData.field_name}`);
            if (data.length === 0) {
              window.vueImg.close();
              return true;
            }
            data[0].click();
          });
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    /*
       * 子层传值 关闭dialog对话框
       * */
    dialogDiskVisible(cb) {
      this.setDataVisible = cb.isdialog;
      this.getDiskInfo();
    },
    /*
       * 上传成功 请求刷新页面
       * */
    uploadGetInfo(cb) {
      if (cb === true) {
        this.getDiskInfo();
      }
    },
    checkImg(url) {
      let isImg = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];
      let strTemp = url.split('.');
      let strCheck = strTemp[strTemp.length - 1];
      let result = 0;
      if (this.isInArray(isImg, strCheck)) {
        result = 1;
      } else {
        result = 2;
      }
      return result;
    },
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    if (this.uploadData.crm_id) {
      this.getDiskInfo();
    }
  },
  computed: {
  },
  components: {
    'jm-newTableCheckbox': newTableCheckbox, // 设置材料
    jmUploadFile,
  },
  watch: {
    'uploadData.crm_id'() {
      this.getDiskInfo();
    }
  }
};
</script>
<style scoped>
  .cycle-noconfirmed{
    background: #ccc;
    color: #fff;
  }
  .hover-cloud:hover .hover-mask{
    width: 100%;
    display: flex;
  }
  .hover-cloud .hover-mask{
    width: 100%;
    display: none;
  }
  .hover-cloud:hover .hover-mask2{
    width: 100%;
    display: none;
  }
  .hover-cloud .hover-mask2{
    width: 100%;
    display: block;
  }
  .cloud-wrap{
    background: #fff;
    min-height: 120px;
  }
  .noCycle-main > .el-checkbox-group {
    font-size: 100%;
  }
  .noCycle-main > div{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    padding: 6px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
  }
  .cycle-cont{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
  }
  .cycle-ico{
    /*background: url("../../../src/assets/images/cycle-ico.png") no-repeat;*/
    display: block;
    width: 45px;
    height:45px;
    margin: 10px auto;
  }
  .cycle-confirmed .cycle-ico{
    /*background: url("../../../src/assets/images/cycle-ico1.png") no-repeat;*/
  }
  .cycle-confirmed{
    background: #3368fa;
    color: #fff;
  }
  .confirmed{
    position: absolute;
    right: 0px;
    top: 5px;
    padding: 2px 8px;
    background: #ffcd38;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #424141;
    font-size: 12px;
  }
  .cycle-hover{
    width: 100%;
    display: flex;
    background: #f2f2f2;
    border: solid #e7e7e7 1px;
    align-items: center;
    flex-wrap:wrap;
  }
  .cycle-hover > div{
    width: 50%;
    text-align: center;
  }
  .cloudSet{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    margin: 10px;
    padding: 6px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
  }
  .cloudSet i {
    margin: 6px auto;
    text-align: center;
    font-size: 100px;
    line-height:60px;
    color: #3368fa;
  }
  .left-rotate{
    position: fixed;
    bottom:20px;
    left:45%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    /*background: #fff url(../../../src/assets/images/icon-rotate-l.png) no-repeat center;*/
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .right-rotate{
    position: fixed;
    bottom:20px;
    left:49%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    /*background: #fff url(../../../src/assets/images/icon-rotate-r.png) no-repeat center;*/
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .save-rotate{
    position: fixed;
    bottom:20px;
    left:53%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .del-rotate{
    position: fixed;
    bottom:20px;
    left:50%;
    width: 50px;
    margin-left: -25px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .left-rotate:hover,.right-rotate:hover,.save-rotate:hover.del-rotate:hover{
    opacity:1;
  }
  .save-rotate:after{
    content:"保存";
  }
  .del-rotate:after{
    content: "删除";
  }
  .content-v-img{
    text-align: center;
  }
  .content-v-img canvas {
    pointer-events: none;
  }
  .cycle-ico{
    font-size: 40px;
  }
</style>
